/**
 * Labstep
 *
 * @module components/ResourceLocation/Form/Edit
 * @desc Editable ResourceLocation - Auto save on change
 */

import { EditFormUpdateContainer as EditForm } from 'labstep-web/core/Form/Edit';
import type React from 'react';
import { fieldResourceLocationName } from '../fields';
import type { IResourceLocationFormEditProps } from './types';

export const ResourceLocationFormEdit: React.FC<
  IResourceLocationFormEditProps
> = ({ resourceLocation, options }) => (
  <EditForm
    entityName="resource_location"
    entity={resourceLocation}
    fields={[fieldResourceLocationName]}
    options={options}
  />
);
